// TODO: how to config this from the theme?
require("./src/prismjs/themes/prism-vs-code-dark.css");
